import { pipe, prop, propOr } from 'lodash/fp';

import { MODULE_NAME, PROP_FRIENDS_AND_FAMILY } from './constants';

const moduleSelector = prop(MODULE_NAME);

/**
 * @type {(state: any) => boolean}
 */
export const friendsAndFamilyMemberSelector = pipe(
	moduleSelector,
	propOr(false, PROP_FRIENDS_AND_FAMILY)
);
